import { createFileRoute } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/solutions/teams/$slug")({
  loader: async ({ params }) => {
    const page = await loadBlockPage({
      data: { collection: "solutions-teams", slug: params.slug },
    });
    return {
      slug: page.slug,
      title: page.title,
      seo_title: page.seo_title,
      seo_description: page.seo_description,
      robots: page.robots,
      blocks: page.blocks || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.seo_title || loaderData.title,
          description: loaderData.seo_description || "",
          url: `/solutions/teams/${loaderData.slug}`,
          noindex: loaderData.robots === "noindex",
        })
      : [],
    links: loaderData
      ? seoLinks({ url: `/solutions/teams/${loaderData.slug}` })
      : [],
  }),
  component: TeamPage,
});

function TeamPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
